import { render, staticRenderFns } from "./Dashboard168Widget.vue?vue&type=template&id=81649568&scoped=true"
import script from "./Dashboard168Widget.vue?vue&type=script&lang=js"
export * from "./Dashboard168Widget.vue?vue&type=script&lang=js"
import style0 from "./Dashboard168Widget.vue?vue&type=style&index=0&id=81649568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81649568",
  null
  
)

export default component.exports